<template>

    <checkout-page
        :addresses="addresses"
        :billingaddress="billingaddress"
        :boxes="boxes"
        :cart="getCart"
        :co="co"
        :defaultaddresses="defaultaddresses"
        :necktag="necktag"
        :notax="notax"
        :ntrequired="ntrequired"
        :taxnumber="taxnumber"
    ></checkout-page>

</template>

<script>

import CheckoutPage from "./Index.vue";
import {mapGetters} from "vuex";
import Layout from "../../../Shared/Layout.vue";

export default {

    computed: {
        ...mapGetters([
            'getCart',
        ]),
    },

    components: {
        CheckoutPage,
    },

    layout:Layout,

    name: 'AuthCheckoutWrapper',

    props: {
        addresses: {
            type:Object,
            required:true,
        },
        billingaddress: {
            type:Object,
            requiredl:true,
        },
        boxes: {
            type:Number,
            required:true,
        },
        co: {
            type:Boolean,
            required:true,
        },
        defaultaddresses: {
            type:Object,
            required:true,
        },
        necktag: {
            required:true,
            type:Object,
        },
        notax: {
            required:true,
            type:Boolean,
            default:false,
        },
        ntrequired: {
            required:true,
            type:Boolean,
        },
        taxnumber: {
            type:String,
            default:null,
        },
    },

}

</script>
